<custom-navbar barTitle="비밀번호 변경" [showSetting]="false"></custom-navbar>
<div class="change-pwd-wrap">
  <div class="change-pwd-userInfo">
    <span>안녕하세요</span>
    <div>
      <div class="change-pwd-userInfo-userId">{{id}}</div>님
    </div>
  </div>
  <div class="change-pwd-warning">
    안전한 개인정보 보호를 위해 비밀번호를<br>다시 한번 확인해 주시기 바랍니다.
  </div>
  <form class="change-pwd-form" (ngSubmit)="submit()">
    <input type="password" [(ngModel)]="nowPwd" placeholder="비밀번호를 입력해주세요" name="nowPwd" required>
    <input type="password" [(ngModel)]="changePwd1" placeholder="변경할 비밀번호를 입력해주세요" name="changePwd1" required>
    <input type="password" [(ngModel)]="changePwd2" placeholder="한번 더 입력해주세요" name="changePwd2" required>
    <div class="change-pwd-error">
      <div *ngIf="isError()">변경할 비밀번호가 서로 다릅니다.</div>
    </div>
    <button mat-button type="submit">비밀번호 변경하기</button>
  </form>
</div>
